<template>
  <v-container fill-height justify-content-start :class="{'pa-2': $vuetify.breakpoint.xsOnly}" class="app-section-width">
    <v-layout column>
      <v-flex class="app-scroll-section pt-2">
      <template v-if="!differentDatesOnBookings">
        <v-text-field
          :label="$t('fields.checkin')"
          :value="checkin"
          append-icon="mdi-calendar"
          outlined
          readonly
        ></v-text-field>
        <v-text-field
          :label="$t('fields.checkout')"
          :value="checkout"
          append-icon="mdi-calendar"
          outlined
          readonly
        ></v-text-field>
      </template>
        <booking-info
          class="pt-4"
          v-for="booking in roomsByBooking"
          :key="booking.booking.id"
          :roomsByBooking="booking"
          :differentDatesOnBookings="differentDatesOnBookings"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import routeNames from '../router/routes'
import router from '@/router'
import { mapState, mapGetters } from 'vuex'
import { displayFormatDateAndHour } from '@/lib/helpers/DateUtils'

export default {
  components: {
    BookingInfo: () => import('@/components/view-components/BookingInfo.vue'),
  },
  methods: {
    exit () {
      router.push({ name: routeNames.main.name })
    },
  },
  computed: {
    ...mapGetters({
      getDashboardName: 'service/getDashboardName',
    }),
    checkin () {
      return this.roomsByBooking[0] && this.roomsByBooking[0].booking.checkin ?
        displayFormatDateAndHour(moment(this.roomsByBooking[0].booking.checkin).local(), this.validateReservationPeriod)
        : ''
    },
    checkout () {
      return this.roomsByBooking[0] && this.roomsByBooking[0].booking.checkout ?
        displayFormatDateAndHour(moment(this.roomsByBooking[0].booking.checkout).local(), this.validateReservationPeriod)
        : ''
    },
    validateReservationPeriod () {
      return moment(this.roomsByBooking[0].booking.checkout).local().diff(
        moment(this.roomsByBooking[0].booking.checkin).local(), 'years'
      ) >= 1
    },
    roomsByBooking () {
      return this.$store.getters['me/roomsByBooking']
    },
    differentDatesOnBookings () {
      var checkin = null
      var checkout = null
      return this.roomsByBooking.some(decoratedBooking => {
        if (checkin === null) {
          checkin = decoratedBooking.booking.checkin
        }
        if (checkout === null) {
          checkout = decoratedBooking.booking.checkout
        }
        if (decoratedBooking.booking.checkin !== checkin || decoratedBooking.booking.checkout !== checkout) {
          return true
        } else {
          return false
        }
      })
    },
    ...mapState(['me']),
  },
  created () {
    this.$store.dispatch('me/getBookings')
  },
}
</script>

<style lang="scss">

.booking-room {
  margin-bottom: 30px;

  .booking-room-name {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 500;
    margin-bottom: 16px;
  }

  .v-btn-booking-guest {
    border: double 1px transparent;
    background: linear-gradient(white, white), linear-gradient(225deg, var(--v-primary-lighten1), var(--v-primary-darken1));
    background-origin: border-box;
    background-clip: content-box, border-box;
    padding: 0 !important;

    &:last-child {
      margin-bottom: 0 !important;
    }
  }
}
</style>
